import { Message } from 'element-ui'

function ShowMsg(msg) {
    Message({
        message: msg,
        type: 'warning',
        duration: 5 * 1000
    })
}

export default{
    ShowMsg,
}

export const URL = {
    Box: 'https://charging.whzkc.com/mp/box/',   //https://ct.vbaymax.com   https://charging.whzkc.com/mp/box/
    cabinet:'https://charging.whzkc.com/mp/cabinet/',
    socket:'https://charging.whzkc.com/mp/socket/',
    coupon:'https://charging.whzkc.com/mp/coupon/',

    // Box: 'https://ct.vbaymax.com/mp/box/',   //https://ct.vbaymax.com   https://charging.whzkc.com/mp/box/
    // cabinet:'https://ct.vbaymax.com/mp/cabinet/',
    // socket:'https://ct.vbaymax.com/mp/socket/',
    // coupon:'https://ct.vbaymax.com/mp/coupon/',
};